<template>
    <div class="con">
        <div class="b">
            <span>{{$t('btn5')}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "btn"
    }
</script>

<style lang="scss" scoped>
.con{
    margin: 30px auto;
    width: 120px;
    .b{
        padding-right: 15px;
        width: 120px;
        height: 40px;
        border-radius: 30px;
        text-align: center;
        color: white;
        font-weight: lighter;
        position: relative;
        background-color: #F5AC01;
        cursor: pointer;
        overflow: hidden;
        span{
            z-index: 100;
            position: absolute;
            left:0;
            top:0;
            width:100%;
            height:100%;
            line-height: 40px;
            font-size: 13px;
            box-sizing: border-box;
            overflow: hidden;
        }
    }
   .b::after{
       content: "";
       position: absolute;
       height: 0%;
       left: 50%;
       top: 50%;
       width: 150%;
       z-index: 1;
       /*-webkit-transition: all 0.75s ease 0s;*/
       /*-moz-transition: all 0.75s ease 0s;*/
       /*-o-transition: all 0.75s ease 0s;*/
       transition: all 0.75s ease 0s;
       transform: translateX(-50%) translateY(-50%) rotate(-25deg);
   }
    .b:hover::after{
        background: #3180e8;
        height: 500%;
        transform: translateX(-50%) translateY(-50%) rotate(-25deg);
    }
    @media screen and (max-width:450px){
        width:140px;
    }
}
</style>